import { motion } from "framer-motion";

interface ProgressNavProps {
  current: number;
  total: number;
  onBack?: () => void;
  canGoBack?: boolean;
}

const MAX_VISIBLE_DOTS = 10;

export function ProgressNav({ current, total, onBack, canGoBack = true }: ProgressNavProps) {
  const progress = (current / total) * 100;
  const showDots = total <= MAX_VISIBLE_DOTS;

  return (
    <div className="mx-3 mt-3 flex items-center gap-3 rounded-[18px] glass-nav px-3 py-2">
      {/* 뒤로가기 */}
      <button
        type="button"
        onClick={onBack}
        disabled={!canGoBack || current <= 1}
        className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full transition-all duration-150 ${
          canGoBack && current > 1
            ? "text-brand-600 hover:bg-brand-50 active:bg-brand-100"
            : "text-gray-300 cursor-not-allowed"
        }`}
        aria-label="이전 문항"
      >
        <svg className="h-4 w-4" fill="none" stroke="currentColor" strokeWidth={2.5} viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" d="M15 19l-7-7 7-7" />
        </svg>
      </button>

      {/* 진행 표시 */}
      <div className="flex flex-1 items-center">
        {showDots ? (
          <div className="flex items-center gap-1 w-full">
            {Array.from({ length: total }, (_, i) => (
              <div
                key={i}
                className={`h-1.5 flex-1 rounded-full transition-all duration-300 ${
                  i < current ? "bg-brand-500" : "bg-gray-200"
                }`}
              />
            ))}
          </div>
        ) : (
          <div className="h-1.5 w-full overflow-hidden rounded-full bg-gray-200">
            <motion.div
              className="h-full rounded-full bg-brand-500"
              initial={{ width: 0 }}
              animate={{ width: `${progress}%` }}
              transition={{ type: "spring", stiffness: 200, damping: 30 }}
            />
          </div>
        )}
      </div>

      {/* 단계 텍스트 */}
      <span className="shrink-0 text-xs font-semibold tabular-nums text-brand-600">
        {current}<span className="font-normal text-gray-400">/{total}</span>
      </span>
    </div>
  );
}
